<!--
 * @Author: wangjx
 * @LastEditors: wangjx
 * @Date: 2022-02-16 11:19:48
 * @LastEditTime: 2022-03-09 15:01:48
 * @Description: 数据权限
-->
<template>
  <div id="source_permission_data" v-loading="loadingTree">
    <!-- 中间树结构 -->
    <div class="tree_content h100">
      <div class="left_tree_box center_tree_box bg-F9 h100 pt-3">
        <el-radio-group v-model="treeType" size="small" class="ml-5 tree-tabs-wrapper">
          <el-radio-button label="WEB" ></el-radio-button>
          <el-radio-button label="APP"></el-radio-button>
        </el-radio-group>
        <div class="pl-4 pr-4">
          <el-input
            v-model="centerSearchText"
            class="self-filter-input"
            placeholder="搜索"
            clearable
            @keyup.enter.native="filterTree"
            @input="filterTree"
            @clear="filterTree"
          >
            <i slot="suffix" class="pr-1" @click="filterTree">
              <svg-icon icon-class="input_search" class="cursor-pointer"></svg-icon>
            </i>
          </el-input>
        </div>
        <div class="flex justify-between">
          <div class="pl-4">
            <span class="vertical-bar fnM">资源列表</span>
          </div>

          <div class="pr-4 sicm-sub-text-color text-gray-901">
            <span class="cursor-pointer hover:text-primary" @click="expandTree(true)">展开</span>
            <span class="pr-2 pl-2">|</span>
            <span class="cursor-pointer hover:text-primary" @click="expandTree(false)">收起</span>
          </div>
        </div>
        <div class="overflow-y-scroll tree_height mt-2 pb-1">
          <el-tree
            ref="centerTree"
            class="self-tree data_tree"
            node-key="id"
            :props="defaultProps"
            :data="treeData"
            :highlight-current="true"
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
            @node-expand="handleNodeExpand"
            @node-collapse="handleNodeCollapse"
          >
            <span slot-scope="{ node }" class="self-custom-tree leading-8">
              <span
                :class="node.isCurrent ? '' : node.data.resourceType === 0 ? 'text-blue-3377' : ''"
              >
                {{ node.label }}
              </span>
            </span>
          </el-tree>
        </div>
      </div>

      <!-- 右边内容 -->
      <div class="right_content mt-3">
        <div class="flex justify-between">
          <el-radio-group v-model="listType" size="small">
            <el-radio-button label="quick">快速配置</el-radio-button>
            <el-radio-button label="filed">按字段值</el-radio-button>
          </el-radio-group>

          <div>
            <el-button
              v-if="listType === 'quick'"
              type="primary"
              :loading="saving"
              class="w-20"
              :disabled="commonResource.dataScopeType === ''"
              @click="handleConfrimSave()"
            >
              保存
            </el-button>
          </div>
        </div>
        <div
          v-show="listType === 'quick'"
          v-loading="loadingQuick"
          class="content_box mt-3 border-solid border-EB border flex"
        >
          <div class="h-full w-1/3 border-solid border-EB border-r pl-4">
            <div class="pt-4 pb-2 scim-text-color fn14">选择数据集查看方式</div>
            <el-radio-group v-model="commonResource.dataScopeType" class="flex-col">
              <el-radio label="ALL">全部</el-radio>
              <el-radio label="TRANS_DEPT">跨部门</el-radio>
              <el-radio label="OWN_CHILD">本级及子级</el-radio>
              <el-radio label="OWN">本级</el-radio>
              <el-radio label="ONESELF">自己</el-radio>
            </el-radio-group>
          </div>
          <div class="h-full w-2/3">
            <div v-if="commonResource.dataScopeType === 'TRANS_DEPT'" class="h100">
              <div class="pl-4 pr-4 w-2/5 pt-3">
                <el-input
                  v-model="departSearchText"
                  class="self-filter-input"
                  placeholder="搜索"
                  clearable
                  @keyup.enter.native="filterDepartTree"
                  @input="filterDepartTree"
                  @clear="filterDepartTree"
                >
                  <i slot="suffix" class="pr-1" @click="filterDepartTree">
                    <svg-icon icon-class="input_search" class="cursor-pointer"></svg-icon>
                  </i>
                </el-input>
              </div>
              <div class="w100 overflow-auto depart_tree">
                <el-tree
                  ref="depart_tree"
                  class="self-tree data_tree"
                  node-key="id"
                  show-checkbox
                  default-expand-all
                  check-on-click-node
                  :expand-on-click-node="false"
                  :props="{ children: 'children', label: 'orgName' }"
                  :data="departTree"
                  :check-strictly="true"
                  :filter-node-method="filterNode"
                  @check-change="departCheckChange"
                >
                  <!-- <span
                      slot-scope="{ node }"
                      :title="node.label"
                      class="self-custom-tree"
                    >
                      <span style="padding-right: 10px">{{ node.label }}</span>
                    </span> -->
                </el-tree>
              </div>
            </div>
          </div>
        </div>

        <div v-show="listType === 'filed'" class="h-64">
          <div class="table_wrap">
            <general-table
              code="PermissionData"
              :columns="tableHeaders"
              :data="tableData"
              :no-pagination="true"
              :hide-oper-button="true"
              :operable-width="100"
              :loading="loadingCustom"
              title="规则列表"
            >
              <template #operations>
                <el-button type="primary" class="w-20" @click="addNewPlan()">新增</el-button>
              </template>
              <template #operation="{ scope }">
                <el-button type="text" class="cursor-p" @click="handleModalShow(scope.row)">
                  {{ $t('common.edit') }}
                </el-button>
                <el-button type="text" class="cursor-p" @click="handleDeleteShow(scope.row)">
                  <span class="text-red-E6">{{ $t('common.delete') }}</span>
                </el-button>
              </template>
            </general-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <el-dialog
      width="30%"
      title="新增方案"
      :visible.sync="addDialogVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="planForm"
        :model="solution"
        label-position="top"
        label-width="100px"
        :rules="rules"
      >
        <el-form-item label="名称" prop="planName">
          <el-input v-model="solution.planName" :maxlength="10"></el-input>
        </el-form-item>

        <el-form-item label="业务对象" prop="structCode">
          <el-select
            v-model="solution.structCode"
            class="w-full"
            placeholder="请选择"
            @change="changeStruct"
          >
            <el-option
              v-for="item in metadata"
              :key="item.structCode"
              :label="item.structName"
              :value="item.structCode"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button plain @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary">确定</el-button>
      </div>
    </el-dialog>

    <dataMeta
      v-if="editDataMeta"
      :visible.sync="editDataMeta"
      :target-id="targetId"
      :target-type="targetType"
      :type="dataMetaType"
      :resource-id="centerCurrentNode.id"
      :default-data="selectedTableItem"
      class="h100"
      @dataMetaChange="dataMetaChange"
    />
    <!-- 删除 -->
    <delete-dialog
      layout="left"
      :visible.sync="deleteDialogVisible"
      :content="deleteContent"
      :loading.sync="deleteLoading"
      @confirm="handleConfirmDelete"
    />
  </div>
</template>

<script>
import dataApi from "@/api/data-permission/dataPermission";
import { mapGetters } from "vuex";
import { commonFilterNode } from "@/utils";
import GeneralTable from "@/components/common/GeneralTable";
import dataMeta from "./assign-permission-data-meta";
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";

export default {
  name: "PermissionData",
  components: {
    GeneralTable,
    dataMeta,
    DeleteDialog
  },
  props: {
    targetId: {
      type: String,
      default() {
        return "";
      }
    },
    targetType: {
      type: String,
      default() {
        return "2";
      }
    }
  },
  data() {
    return {
      solution: {
        planName: null,
        structCode: null
      },
      tableHeaders: [
        {
          label: "名称",
          key: "ruleName",
          hidden: false,
          fixed: false
        },
        {
          label: "业务对象",
          key: "bizCode",
          hidden: false,
          fixed: false
        }
      ],
      tableData: [],
      rules: {
        planName: [{ required: true, message: "请输入方案名称", trigger: "blur" }],
        structCode: [{ required: true, message: "请选择业务对象", trigger: "blur" }]
      },
      loading: true,
      saving: false,
      centerSearchText: "",
      defaultProps: {
        children: "children",
        label: "resourceName"
      },
      departSearchText: "",
      defaultShowNodes: [],
      departTree: [],
      treeData: [],
      listType: "quick",
      selectedStructCode: "",
      selectedStruct: {},
      selectedTableItem: null,
      metadata: {},
      metadataDetail: {},
      addDialogVisible: false,
      editDataMeta: false,
      dataMetaType: "",
      loadingTree: false,
      loadingQuick: false,
      loadingCustom: false,
      centerCurrentNode: "",
      commonResource: {
        resourceId: "",
        dataRulesId: "",
        dataScopeType: "",
        dataScope: []
      },
      deleteContent: {
        title: "删除数据",
        description: "你确认删除选中的数据吗"
      },
      deleteDialogVisible: false,
      deleteLoading: false,
      treeType: "WEB"
    };
  },
  computed: {
    ...mapGetters(["tenantId"])
  },
  watch: {
    targetType() {
      this.getAuthorResourceTree();
    },
    targetId() {
      this.getAuthorResourceTree();
    },
    treeType() {
      this.centerSearchText = "";
      this.filterTree();
      this.getAuthorResourceTree();
    }
  },
  mounted() {
    this.getAuthorResourceTree();
    this.expandTree(false);
    this.getDepartTree();
    this.getMetadataStruct();
    // this.getCenterTreeList();
  },
  methods: {
    // 获取带权限资源树
    getAuthorResourceTree() {
      if (!this.targetId) {
        return;
      }
      this.loadingTree = true;
      this.centerCurrentNode = "";
      return dataApi
        .getAuthorResourceTree(this.targetType, this.targetId, this.treeType, { parseToTree: true })
        .then(res => {
          this.loadingTree = false;
          this.treeData = res.data;
          this.$nextTick(() => {
            if (!this.centerCurrentNode && res.data && res.data.length) {
              const [node] = res.data;
              this.centerCurrentNode = node;
              this.defaultShowNodes.push(node.id);
              this.getCommonResource();
              this.getCustomResource();
            }
            if (this.centerCurrentNode) {
              this.$refs.centerTree && this.$refs.centerTree.setCurrentKey(this.centerCurrentNode.id);
              this.centerCurrentNode = this.$refs.centerTree.getCurrentNode();
            }
          });
        })
        .catch(() => {
          this.loadingTree = false;
        });
    },
    // 获取部门树列表
    getDepartTree() {
      dataApi.getOrganization({ parseToTree: true, withUser: true }, this.tenantId).then(res => {
        this.departTree = [res.data];
      });
    },
    getCustomResource() {
      this.loadingCustom = true;
      this.tableData = [];
      dataApi
        .getCustomResource(this.centerCurrentNode.id, this.targetId)
        .then(res => {
          // this.loadingCustom = false;
          if (res && res.success && res.data) {
            this.$nextTick(() => {
              this.tableData = res.data;
              this.tableData.forEach(element => {
                element.ruleName = element.dataRules.ruleName;
                element.bizCode = element.dataRules.bizCode;
              });
            });
          }
        })
        .catch(() => {
          // this.loadingCustom = false;
        });
    },
    /**
     * @description: 查询租户下元数据结构
     * @param {*}
     * @return {*}
     */
    getMetadataStruct() {
      dataApi
        .getMetadataStruct()
        .then(res => {
          if (res && res.success) {
            this.metadata = res.data;
          }
        })
        .catch(() => {});
    },
    getCommonResource() {
      this.loadingQuick = true;
      this.commonResource = {
        resourceId: "",
        dataRulesId: "",
        dataScopeType: "",
        dataScope: []
      };
      dataApi
        .getCommonResource(this.centerCurrentNode.id, this.targetId)
        .then(res => {
          this.loadingQuick = false;
          if (res && res.success && res.data) {
            this.commonResource = res.data;
            this.$nextTick(() => {
              this.$refs.depart_tree &&
                this.$refs.depart_tree.setCheckedKeys(this.commonResource.dataScope);
            });
          }
        })
        .catch(() => {
          this.loadingQuick = false;
        });
    },
    addNewPlan() {
      this.selectedTableItem = null;
      this.editDataMeta = true;
      this.dataMetaType = "add";
    },
    handleConfrimSave() {
      // this.editDataMeta = true;
      let type = "ROLE";
      switch (this.targetType) {
        case "1":
          type = "DEPT";
          break;
        case "2":
          type = "ROLE";
          break;
        case "3":
          type = "USER";
          break;

        default:
          break;
      }
      const data = {
        id: this.commonResource.id,
        dataScopeType: this.commonResource.dataScopeType,
        resourceId: this.centerCurrentNode.id,
        targetId: this.targetId,
        dataRulesId: this.commonResource.dataRulesId,
        targetType: type,
        dataScope: this.commonResource.dataScope
      };
      this.saving = true;
      dataApi
        .saveCommonResource(data)
        .then(res => {
          this.saving = false;
          if (res && res.success) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.saving = false;
        });
    },
    handleModalShow(item) {
      this.editDataMeta = true;
      this.dataMetaType = "edit";
      this.selectedTableItem = item;
    },

    /**
     * @description:
     * @param {*} item
     * @return {*}
     */
    handleDeleteShow(item) {
      this.deleteDialogVisible = true;
      this.selectedTableItem = item;
      this.deleteContent.description = `你确认删除吗${item.ruleName}?`;
    },
    handleConfirmDelete() {
      this.deleteLoading = true;
      dataApi
        .deleteDataPermissionById(this.selectedTableItem.id)
        .then(res => {
          if (res && res.success) {
            this.deleteDialogVisible = false;
            this.deleteLoading = false;
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getCustomResource();
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.deleteLoading = false;
        });
    },
    /**
     * @description:展开收起菜单树
     * @param {*} expand
     * @return {*}
     */
    expandTree(expand) {
      const nodesMap = this.$refs.centerTree.store.nodesMap;
      for (const key in nodesMap) {
        // 全部关闭
        if (key === "-2") {
          nodesMap[key].expanded = true;
        } else {
          nodesMap[key].expanded = expand;
        }
      }
    },

    filterTree() {
      this.$refs.centerTree.filter(this.centerSearchText);
    },
    filterDepartTree() {
      this.$refs.depart_tree.filter(this.departSearchText);
    },
    // 节点筛选
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultShowNodes.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultShowNodes.push(data.id);
      }
    },
    handleNodeCollapse(data) {
      this.defaultShowNodes.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.defaultShowNodes.length = i;
        }
      });
    },

    handleNodeClick(node) {
      this.centerCurrentNode = node;
      this.getCommonResource();
      this.getCustomResource();
    },
    departCheckChange() {
      this.commonResource.dataScope = this.$refs.depart_tree.getCheckedKeys();
    },
    changeStruct(value) {
      const item = this.metadataDetail[value];
      if (item) {
        this.selectedStruct = item;
      } else {
        dataApi
          .getMetadataStructByCode(value)
          .then(res => {
            if (res && res.data) {
              this.metadataDetail[value] = res.data;
              this.selectedStruct = res.data;
            }
          })
          .catch(() => {});
      }
    },
    dataMetaChange() {
      this.getCustomResource();
    }
  }
};
</script>

<style scoped lang="scss">
#source_permission_data {
  width: 100%;
  height: 100%;
  display: flex;
  .left_tree_box {
    width: 224px;
    margin-left: 0;
    transition: all 0.25s linear;
    background-color: #f9f9fb;
    position: relative;
    .data_tree {
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      .el-icon-more {
        transform: rotate(90deg);
      }
    }
    .data_tree::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  .fade-left-enter-active,
  .fade-left-leave-active {
    transition: all 0.2s ease-in;
    flex: 0 224px;
  }

  .fade-left-enter-from,
  .fade-left-leave-to {
    flex: 0 0;
  }
  .tree_content {
    display: flex;
    flex: 1;
    transition: all 0.2s ease-in;
    min-width: calc(100% - 324px);
    .center_tree_box {
      position: relative;
      flex: 0 244px;
      width: 324px;
    }
    .right_content {
      flex: 1;
      height: 100%;
      padding-left: 16px;
      padding-right: 24px;
      width: calc(100% - 324px);

      .content_box {
        width: 100%;
        height: calc(100% - 48px);
      }
    }
  }

  .plain_button {
    color: #505363;
    background-color: #fff;
    border-color: #9da5b2;
  }

  .depart_tree {
    height: calc(100% - 60px);
  }
}
</style>

<style lang="scss">
#source_permission_data {
  .el-radio-group {
    margin-top: 0px;
  }
  .el-radio {
    height: 32px;
  }
  .self-filter-input {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
    .el-input__icon {
      color: #9da5b2;
      line-height: 32px;
    }
  }
  .el-radio-button {
    margin-top: 0px;
    .el-radio-button__inner {
      padding: 8px 10px;
      width: 88px;
      font-size: 14px;
    }
  }

  .tree_height {
    height: calc(100% - 110px);
  }

  .table_wrap {
    height: calc(100% - 180px);
  }
  .tree-tabs-wrapper {
    .el-radio-button {
      .el-radio-button__inner {
        width: 103px;
        font-size: 12px;
      }
    }
  }
}
</style>
